module.exports = __webpack_public_path__ + "img/ac1.3cc8f98e.png";